import {
  Stack,
  Text,
  Box,
  Heading,
  Page,
  PageBlock,
  TextLink,
  List,
} from 'braid-design-system';

import { SiteWideFooter } from 'src/components/SiteWideFooter';
import { getConfigValues } from 'src/config';
import { createDotNetLinkUrl } from 'src/utils';

import { createNavLinks } from '../../shared-static-components/components/NavigationHeader/utils/generalUtils';

const NotFound = () => {
  const baseUrl = getConfigValues().HEADER_SERVER_BASE;
  const links = createNavLinks(baseUrl);

  return (
    <Page footer={<SiteWideFooter />}>
      <Box paddingTop="xlarge">
        <PageBlock width="small">
          <Stack space="large">
            <Heading level="2" component="h1">
              Page not found
            </Heading>

            <Text>
              We can&apos;t find that page. It may be an invalid URL, or the
              page may have moved.
            </Text>

            <Heading level="3" component="h3">
              Ready to take the next step?
            </Heading>

            <List>
              <Text>
                <TextLink href={links.businessesForSale}>
                  Search business listings
                </TextLink>
              </Text>
              <Text>
                <TextLink href={links.sellABusiness}>Sell a business</TextLink>
              </Text>
              <Text>
                <TextLink href={links.signIn}>Sign in</TextLink> to your account
              </Text>
            </List>

            <Text>
              Or, return to the{' '}
              <TextLink href={createDotNetLinkUrl('/')}>
                SEEK Business Homepage
              </TextLink>
              .
            </Text>
          </Stack>
        </PageBlock>
      </Box>
    </Page>
  );
};

export default NotFound;
